// Keep in sync with benchling/inventory/sample_controls_feature_level.py

export enum SampleControlsFeatureLevel {
  OFF = 'OFF',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
}
